<template>
  <div>
    <div class="px-5 sm:px-20 mt-10 pt-5" :class="{'!p-0 !mt-0': isModal}">
      <div
        class="grid grid-cols-12 gap-4 gap-y-5 mt-5 items-baseline"
        data-test="welfare-form"
      >
        <div class="font-medium text-base col-span-12">
          สิทธิสวัสดิการที่ได้รับในปัจจุบัน (ย้อนหลังไม่เกิน 1 ปีงบประมาณ)
        </div>
        <div class="col-span-12">
          <div
            :id="`faq-accordion-${key}`"
            class="accordion accordion-boxed"
            :class="{'mt-5':key>0}"
            v-for="(data,key) in data_welfare"
            :key="key"
          >
            <div class="accordion-item">
              <div
                :id="`faq-accordion-content-${key}`"
                class="accordion-header"
              >
              <!--accordion button with welfare each group-->
                <button
                  class="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  :data-bs-target="`#faq-accordion-collapse-${key}`"
                  aria-expanded="true"
                  :aria-controls="`faq-accordion-collapse-${key}`"
                >
                  {{data.desc}}
                </button>
              </div>
              <div
                :id="`faq-accordion-collapse-${key}`"
                class="accordion-collapse collapse show"
                :aria-labelledby="`faq-accordion-content-${key}`"
                :data-bs-parent="`#faq-accordion-${key}`"
              >
                <div
                  class="accordion-body text-gray-700 dark:text-gray-600 leading-relaxed gap-4 gap-y-5 grid grid-cols-12 ml-6"
                >
                  <div
                    class="col-span-12 sm:col-span-6 grid"
                    v-for="(choice,key2) in data.choices"
                    :key="key2"
                  >
                    <!--checkbox answer level 1 for each group-->
                    <div class="form-checkbox-custom pl-6 sm:flex">
                      <div class="mr-3">
                        <label
                          class="form-check-label align-middle mr-2"
                          :for="`form-input-welfare-${choice.option.code}`"
                        >
                          <input
                            :id="`form-input-welfare-${choice.option.code}`"
                            class="form-check-input align-middle"
                            type="checkbox"
                            :value="choice.option"
                            v-model="form.welfareObj[data.name]"
                          >
                          {{choice.option.desc}}
                        </label>
                      </div>
                      <div class="form-input-for-checkbox" v-if="choice.specify && form.welfareObj[data.name].some(({code})=> code == choice.option.code)">
                        <input
                          type="text"
                          class="form-control mt-2"
                          placeholder="กรุณาระบุ"
                          :data-test="`welfare-choice-${key2}`"
                          v-model="form.welfareObj[data.name][form.welfareObj[data.name].findIndex(p => p.code == choice.option.code)].name"
                          :class="{ 'border-1 border-theme-24 rounded-md': validate.welfareObj[data.name].$each.$response.$errors[form.welfareObj[data.name].findIndex(p => p.code == choice.option.code)].name.length}"
                        >
                        <template v-if="validate.welfareObj[data.name].$each.$response.$errors[form.welfareObj[data.name].findIndex(p => p.code == choice.option.code)].name.length">
                          <div
                            v-for="(error, index) in validate.welfareObj[data.name].$each.$response.$errors[form.welfareObj[data.name].findIndex(p => p.code == choice.option.code)].name"
                            :key="index"
                            class="text-theme-24 mt-1 text-xs"
                          >
                            {{ error.$message }}
                          </div>
                        </template>
                      </div>
                    </div>
                    <div v-if="choice.sub && form.welfareObj[data.name].some(({code})=> code == choice.option.code)">
                      <div class="ml-6" :class="{ 'border-1 border-theme-24 rounded-md p-2': validate.welfareObj[choice.name].$error || validate.welfareObj[choice.name].$invalid }">
                        <!--checkbox answer level 2 for group checkbox-->
                        <div
                          class="form-checkbox-custom pl-6 mt-5 sm:flex"
                          v-for="(sub, skey) in choice.sub"
                          :key="skey"
                        >
                          <div class="mr-3">
                            <label
                              class="form-check-label align-middle mr-2"
                              :for="`form-input-subsidy-${skey}`"
                            >
                              <input
                                :id="`form-input-subsidy-${skey}`"
                                class="form-check-input align-middle"
                                type="checkbox"
                                v-model="form.welfareObj[choice.name]"
                                :value="sub.option"
                                @change="validate.welfareObj[choice.name].$touch()"
                              >
                              {{sub.option.type}}
                            </label>
                          </div>
                          <div class="form-input-for-checkbox" v-if="sub.specify && form.welfareObj[choice.name].some(({code})=> code == sub.option.code)">
                            <input
                              type="number"
                              min="0"
                              class="form-control"
                              placeholder="กรุณาระบุจำนวนเงิน"
                              v-model="form.welfareObj[choice.name][form.welfareObj[choice.name].findIndex(p => p.code == sub.option.code)].amount"
                            >
                          </div>
                          <!--input answer for checkbox level 2-->
                          <div v-if="sub.option.type == 'เงินสงเคราะห์เด็กในครอบครัวยากจน' && form.welfareObj[choice.name].some(({type})=> type == sub.option.type)">
                            <div>
                              <label>ครั้งที่ 1/ปี จำนวน(บาท)</label>
                              <input
                                type="number"
                                min="0"
                                class="form-control mt-2"
                                placeholder="กรุณาระบุจำนวนเงิน"
                                data-test="form-subsidy-1st"
                                v-model="form.first_subsidy"
                                @input="insertFirstSubsidy"
                              >
                            </div>
                            <div
                              class="mt-5 "
                            >
                              <label>ครั้งที่ 2/ปี จำนวน(บาท)</label>
                              <input
                                type="number"
                                min="0"
                                class="form-control mt-2"
                                placeholder="กรุณาระบุจำนวนเงิน"
                                data-test="form-subsidy-2nd"
                                v-model="form.second_subsidy"
                                @input="insertSecondSubsidy"
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <template v-if="validate.welfareObj[choice.name].$error || validate.welfareObj[choice.name].$invalid">
                        <div class="text-theme-24 mt-1 text-xs ml-6">
                          {{validate.welfareObj[choice.name].required.$message}}
                        </div>
                      </template>
                    </div>
                    <!--input answer for checkbox level 2-->
                    <div
                      :class="`flex ml-6`"
                      v-if="choice.plusMore && form.welfareObj[data.name].some(({code})=> code == choice.option.code)"
                    >
                      <!-- <select
                        class="form-select mr-1"
                        data-test="form-cy-education"
                        v-model="form.welfareObj[choice.name]"
                        style="height:38px;"
                      >
                        <option v-for="(sc, sckey) in dataAge.age_range" :key="sckey" :value="sc.option">{{sc.option.desc}}</option>
                      </select> -->
                      <div class="grid grid-cols-12 gap-1 gap-y-3">
                        <div class="col-span-12 lg:col-span-6">
                          <!-- <treeselect v-model="validate.welfareObj.edu_select.$model" :multiple="false" :searchable="false" :options="dataAge.age_range" placeholder="การศึกษาตามช่วงวัย" :normalizer="normalizer" data-test="form-cy-education" :class="{ 'border-1 border-theme-24 rounded-md': validate.welfareObj.edu_select.$error || validate.welfareObj.edu_select.$invalid }">
                            <label slot="option-label" slot-scope="{ node }">
                              {{ node.label }}
                            </label>
                          </treeselect> -->
                          <v-select
                            :clearable="false"
                            data-test="form-cy-education"
                            v-model="validate.welfareObj.cy_education.$model"
                            :searchable="false"
                            :options="data_age_range"
                            placeholder="การศึกษา"
                            label="label"
                            :class="{ 'border-1 border-theme-24 rounded-md': validate.welfareObj.cy_education.$error || validate.welfareObj.cy_education.$invalid}"
                            :reduce="label => label.option"
                          >
                            <template #open-indicator="{ attributes }">
                              <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                            </template>
                          </v-select>
                          <template v-if="validate.welfareObj.cy_education.$error || validate.welfareObj.cy_education.$invalid">
                            <div class="text-theme-24 mt-1 text-xs">
                              {{validate.welfareObj.cy_education.required.$message}}
                            </div>
                          </template>
                        </div>
                        <div class="col-span-12 lg:col-span-6">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="กรุณาระบุ"
                            data-test="form-input-cy-edu"
                            style="height:38px;"
                            v-model="validate.welfareObj[choice.name].name.$model"
                            :class="{ 'border-1 border-theme-24 rounded-md': validate.welfareObj[choice.name].name.$error || validate.welfareObj[choice.name].name.$invalid }"
                          >
                          <template v-if="validate.welfareObj[choice.name].name.$error || validate.welfareObj[choice.name].name.$invalid">
                            <div class="text-theme-24 mt-1 text-xs">
                              {{validate.welfareObj[choice.name].name.required.$message}}
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="col-span-12 mt-10">
    </div>
    <div
    class="col-span-12 flex items-center mt-10 justify-end"
    v-if="isModal"
    >
      <div>
        <button
        class="btn btn-outline-secondary"
        data-dismiss="modal"
        @click="cancelModalButton"
        >
        ยกเลิก
        </button>
        <button
        class="btn btn-primary ml-2"
        @click="nextStep"
        >
        บันทึก
        </button>
      </div>
    </div>
    <div
      class="col-span-12 flex items-center mt-10 px-5 sm:px-20 justify-between"
      v-else
    >
      <div>
          <button
          class="btn btn-secondary"
          @click="closeWizardForm"
          >
          ออก
          </button>
          <button
          class="btn btn-secondary ml-2"
          @click="skipStep"
          >
          ข้าม
          </button>
      </div>
      <div>
          <button
          class="btn btn-secondary ml-2"
          @click="prevStep"
          >
          ย้อนกลับ
          </button>
          <button
          class="btn btn-primary ml-2"
          @click="nextStep"
          >
          บันทึกและถัดไป
          </button>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, defineComponent, watch, ref, toRefs } from 'vue'
import dataJson from '@/data/welfare.json'
import dataAge from '@/data/general.json'
// import Treeselect from 'vue3-treeselect'
// import 'vue3-treeselect/dist/vue3-treeselect.css'
import useVuelidate from '@vuelidate/core'
import { required, helpers, requiredIf } from '@vuelidate/validators'
import Swal from 'sweetalert2'
import {useStore} from "vuex"
import axios from "axios"
const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})
export default defineComponent({
  props:{
    isModal:{
      type: Boolean,
      default: false
    },
    updateId:{
      type: String
    },
    editData:{
      type: Object
    },
    cancelModal:{
      type: Boolean,
      default: false
    },
    openModal:{
      type: Boolean,
      default: false
    }
  },
  components: {
    // Treeselect
  },
  setup(props,{emit}){
    const form = reactive({
      welfareObj: {
        welf_children_youth:[],
        cy_subsidy:[],
        cy_education: null,
        welf_disability:[],
        welf_women:[],
        welf_eldery:[],
        welf_helpless_persons:[],
        welf_others:[]
      },
      first_subsidy: null,
      second_subsidy: null,
      // edu_select: null
    })
    const formDefault = reactive({
      welfareObj: {
        welf_children_youth:[],
        cy_subsidy:[],
        cy_education: null,
        welf_disability:[],
        welf_women:[],
        welf_eldery:[],
        welf_helpless_persons:[],
        welf_others:[]
      },
      first_subsidy: null,
      second_subsidy: null,
      // edu_select: null
    })
    const data_welfare = reactive(dataJson.welfare)
    const data_age_range = reactive(dataAge.age_range)
    const currStep = ref(4)
    const rules = {
      welfareObj:{
        welf_disability:{
          $each: helpers.forEach({
            name: {
              required: helpers.withMessage(`กรุณาระบุ`, required)
            }
          })
        },
        welf_eldery:{
          $each: helpers.forEach({
            name: {
              required: helpers.withMessage(`กรุณาระบุ`, required)
            }
          })
        },
        cy_subsidy:{
          required: helpers.withMessage(`กรุณาเลือก`, requiredIf(()=>form.welfareObj.welf_children_youth.some(({code})=> code == 'WFCY2'))),
          $each: helpers.forEach({
            amount: {
              required: helpers.withMessage(`กรุณาระบุ`, required)
            }
          })
        },
        cy_education:{
          required: helpers.withMessage(`กรุณาเลือก`, requiredIf(()=>form.welfareObj.welf_children_youth.some(({code})=> code == 'WFCY5'))),
          name:{
            required: helpers.withMessage(`กรุณาระบุ`, requiredIf(()=>form.welfareObj.welf_children_youth.some(({code})=> code == 'WFCY5')))
          }
        },
        // edu_select:{
        //   required: helpers.withMessage(`กรุณาเลือก`, requiredIf(()=>form.welfareObj.welf_children_youth.some(({code})=> code == 'WFCY5')))
        // },
      }
    }
    const validate = useVuelidate(rules, toRefs(form))
    /*watch(
      ()=> form.first_subsidy,(val)=>{
          var index = form.welfareObj.cy_subsidy.findIndex(obj => obj.code == "CYSU2")
          // console.log("ind ",index);
          if(index != -1){
            form.welfareObj.cy_subsidy[index].amount = val
          }
        // }
      },
    )
    watch(
      ()=> form.second_subsidy,(val)=>{
        // if(val){
          // console.log("cy1 ",form.welfareObj.cy_subsidy);
          var index = form.welfareObj.cy_subsidy.findIndex(obj => obj.code == "CYSU3")
          if(index == -1){
            form.welfareObj.cy_subsidy.push({
              code: "CYSU3",
              type: "เงินสงเคราะห์เด็กในครอบครัวยากจนครั้งที่ 2/ปี",
              amount: val
            })
          }else{
            form.welfareObj.cy_subsidy[index].amount = val
          }
        // }
      },
    )*/
    function insertFirstSubsidy(){
      var index = form.welfareObj.cy_subsidy.findIndex(obj => obj.code == "CYSU2")
      if(index != -1){
        form.welfareObj.cy_subsidy[index].amount = form.first_subsidy
      }
    }
    function insertSecondSubsidy(){
      var index = form.welfareObj.cy_subsidy.findIndex(obj => obj.code == "CYSU3")
      if(index == -1){
        form.welfareObj.cy_subsidy.push({
          code: "CYSU3",
          type: "เงินสงเคราะห์เด็กในครอบครัวยากจนครั้งที่ 2/ปี",
          amount: form.second_subsidy
        })
      }
      else if(form.second_subsidy == ""){
        form.welfareObj.cy_subsidy.splice(index,1)
      }
      else{
        form.welfareObj.cy_subsidy[index].amount = form.second_subsidy
      }
    }
    watch(
      ()=> form.welfareObj.cy_subsidy,(val)=>{
        if(val){
          let checkHasPoor = val.some(({code})=>code=="POOR")
          if(!checkHasPoor)
          {
            let index1 = form.welfareObj.cy_subsidy.findIndex(obj => obj.code == "CYSU2")
            if(index1 != -1){
              form.welfareObj.cy_subsidy.splice(index1,1)
              // console.log(form.welfareObj.cy_subsidy);
              form.first_subsidy = null
            }
            let index2 = form.welfareObj.cy_subsidy.findIndex(obj => obj.code == "CYSU3")
            if(index2 != -1){
              form.welfareObj.cy_subsidy.splice(index2,1)
              form.second_subsidy = null
            }
          }
          else{
            let indexPoor = form.welfareObj.cy_subsidy.findIndex(obj => obj.code == "POOR")
            let firstIndex  = form.welfareObj.cy_subsidy.findIndex(obj => obj.code == "CYSU2")
            if(indexPoor != -1 && firstIndex == -1){
              form.welfareObj.cy_subsidy.push({
                code: "CYSU2",
                type: "เงินสงเคราะห์เด็กในครอบครัวยากจนครั้งที่ 1/ปี",
                amount: null
              })
            }
          }
        }
      },
    )
    watch(()=> form.welfareObj.welf_children_youth,(val)=>{
      if(!val.some(({code})=>code == "WFCY5")){
        form.welfareObj.cy_education = null
        data_age_range.forEach((item,index)=>{
          data_age_range[index].option.name = null
        })
      }
      if(!val.some(({code})=>code == "WFCY2")){
        form.welfareObj.cy_subsidy = []
      }
    })
    const store = useStore()
    const token = store.getters["userAuth/getToken"];
    function nextStep(){
      validate.value.$touch()
      if (validate.value.$invalid) {
        return;
      }
      const new_cy_subsidy= form.welfareObj.cy_subsidy.filter(function(x) {
          return x.code != "POOR";
      });
      // let idx = form.welfareObj.cy_subsidy.findIndex(x=>x.code == "POOR")
      // if(idx != -1){
      //   form.welfareObj.cy_subsidy.splice(idx,1)
      // }
      const config = {
        url: `${process.env.VUE_APP_BASE_API}member/${props.isModal ? props.editData._id : props.updateId}`,
        method: "PUT",
        headers:{
            Authorization: `Bearer ${token}`,
            "Content-Type": `application/json; charset=utf-8`,
        },
        data:{
          update:{
            "welf_children_youth": form.welfareObj.welf_children_youth?.length > 0 ? form.welfareObj.welf_children_youth : null,
            "cy_subsidy": new_cy_subsidy?.length > 0 ? new_cy_subsidy : null,
            "cy_education": form.welfareObj.cy_education ? Object.keys(form.welfareObj.cy_education).length > 0 ? form.welfareObj.cy_education : null : null,
            "welf_disability": form.welfareObj.welf_disability?.length > 0 ? form.welfareObj.welf_disability : null,
            "welf_women": form.welfareObj.welf_women?.length > 0 ? form.welfareObj.welf_women : null,
            "welf_eldery": form.welfareObj.welf_eldery?.length > 0 ? form.welfareObj.welf_eldery : null,
            "welf_helpless_persons": form.welfareObj.welf_helpless_persons?.length > 0 ? form.welfareObj.welf_helpless_persons : null,
            "welf_others": form.welfareObj.welf_others?.length > 0 ? form.welfareObj.welf_others : null
          }
        }
      };
      if(props.isModal){
        swalCustom.fire({
          text:"ยืนยันบันทึกข้อมูล",
          icon:"info",
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก',
        }).then((result) => {
          if(result.isConfirmed){
            axios(config)
            .then(() => {
              swalCustom.fire({
                text:"สำเร็จ",
                icon: 'success',
                timer: 3000,
                confirmButtonText: "ปิด",
              }).then(() => {
                cash('#edit-member-modal').modal('hide')
                emit('update-state')
              });
            })
            .catch((error) => {
              swalCustom.fire({
                text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                icon: "warning",
                //timer: 3000, //timeOut for auto-close
                confirmButtonText: "ปิด",
              });
              console.log(error);
            });
          }
        })
      }
      else{
        axios(config)
        .then(() => {
          emit('next-step', currStep.value)
        })
        .catch((error) => {
            swalCustom.fire({
                text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                icon: "warning",
                // timer: 3000, //timeOut for auto-close
                confirmButtonText: "ปิด",
            });
            console.log(error);
        });
      }
    }
    function skipStep(){
      emit('skip-step', currStep.value)
    }
    function closeWizardForm(){
      emit('close-wizard', currStep.value)
    }
    function prevStep(){
      emit('prev-step', currStep.value)
    }
    function normalizer(node) {
      return {
          id: `{"code": "${node.option.code}","desc": "${node.option.desc}"}`,
          label: node.option.desc
      }
    }
    function cancelModalButton(){
        validate.value.$reset()
        emit('cancelButton')
    }
    watch(()=> props.cancelModal,(val)=>{
      if(val){
          Object.assign(form, formDefault)
          validate.value.$reset()
      }
    })
    watch(()=> props.openModal,(val)=>{
      if(val){
        const dataEdit = JSON.parse(JSON.stringify(props.editData))
        let Obj_key = Object.keys(form.welfareObj)
        form.first_subsidy = null
        form.second_subsidy = null
        Obj_key.forEach(key => {
          if(key == "cy_education"){
            if(dataEdit[key] ? Object.keys(dataEdit[key]).length > 0 : false){
              form.welfareObj[key] = dataEdit.cy_education ?  dataEdit.cy_education : null
                let idx_data = data_age_range.findIndex(x => x.option.code == form.welfareObj[key].code);
                data_age_range[idx_data].option = form.welfareObj[key]
            }
          }
          else{
            form.welfareObj[key] = dataEdit[key]?.length > 0 ? dataEdit[key] : []
          }
          if(form.welfareObj[key]?.length > 0 && (key == "welf_eldery" || key == "welf_disability")){
            let idx_data = data_welfare.findIndex(x => x.name == key);
            form.welfareObj[key].forEach(item => {
              let idx_choice = data_welfare[idx_data].choices.findIndex(opt => opt.option.code == item.code)
              data_welfare[idx_data].choices[idx_choice].option = item
            });
          }
          if(form.welfareObj[key]?.length > 0 && form.welfareObj["welf_children_youth"].length > 0 && key == "cy_subsidy"){
            let idx_data = data_welfare.findIndex(x => x.name == "welf_children_youth");
            form.welfareObj["welf_children_youth"].forEach(item => {
              if(item.code == "WFCY2"){
                if(form.welfareObj['cy_subsidy'].some(({type}) => type.includes("เงินสงเคราะห์เด็กในครอบครัวยากจน"))){
                  form.welfareObj.cy_subsidy.push({code: "POOR", type: "เงินสงเคราะห์เด็กในครอบครัวยากจน"})
                }
                let idx_choice = data_welfare[idx_data].choices.findIndex(opt => opt.option.code == item.code)
                form.welfareObj['cy_subsidy'].forEach((subitem)=>{
                  if(subitem.type.includes("เงินสงเคราะห์เด็กในครอบครัวยากจน")){
                    // form.welfareObj.cy_subsidy.push({code: "POOR", type: "เงินสงเคราะห์เด็กในครอบครัวยากจน"})
                    if(subitem.code == "CYSU2"){
                      form.first_subsidy = subitem.amount
                    if(subitem.code == "CYSU3")
                      form.second_subsidy = subitem.amount
                    }
                  }
                  let idx_sub = data_welfare[idx_data].choices[idx_choice].sub.findIndex(s => s.option.code == subitem.code)
                  if(idx_sub != -1)
                    data_welfare[idx_data].choices[idx_choice].sub[idx_sub].option = subitem
                })
              }
            });
          }
        })
      }
    })
    return {
        form,
        nextStep,
        skipStep,
        closeWizardForm,
        prevStep,
        normalizer,
        validate,
        data_welfare,
        data_age_range,
        insertSecondSubsidy,
        insertFirstSubsidy,
        cancelModalButton
    }
  }
})
</script>